/* eslint-disable react/no-danger */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from '../../../styles/partials/form-frame.module.scss';

const propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    children: PropTypes.node,
    className: PropTypes.string,
};

const defaultProps = {
    title: null,
    children: null,
    className: null,
};

const FormFrame = ({ title, children, className }) => (
    <fieldset
        className={classNames({
            [styles.container]: true,
            [className]: className !== null,
        })}
    >
        <h2 className={styles.heading}>{title}</h2>
        {children}
    </fieldset>
);
FormFrame.propTypes = propTypes;
FormFrame.defaultProps = defaultProps;

export default FormFrame;
